export const ADDTOCART = "addtocart";
export const INCREMENT = "increment";
export const DECREASE = "decrement";
export const GETTOTAL = "gettotal";
export const INCREASE = "increase";
